import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import RegisterForm from "../../components/auth/RegisterForm";
import EmailConfirmForm from "../../components/auth/EmailConfirmForm";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const EmailConfirmation = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className=" mt-4 flex flex-col gap-6">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title={Auth?.email_confirmation.email_confirmation_title} />

          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.email_confirmation.email_confirmation_subtitle}
          </p>
        </div>

        <EmailConfirmForm />
      </div>
    </AuthLayout>
  );
};

export default EmailConfirmation;
